import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const getWithdrawals = createAsyncThunk('funding/getWithdrawals', async () => {
	return await AccountService.withdrawals();
});
